<template>
  <div class="d-active">
    <div class="menu">
      <div class="m-item" @click.stop="selectItem(item)" v-for="(item, i) in list" :key="i">
        <div class="c">
          <!-- 参考 components/User.vue：没有头像就不渲染 img，改显示姓名首字圆点（20px，与 .touxiang 同尺寸） -->
          <img alt="" v-if="item.img" :src="baseURL + item.img" class="touxiang">
          <span v-else class="touxiang touxiang-initial" :style="{ background: avatarColor(item.name || item.id) }">{{ avatarInitial(item.name || item.id) }}</span>
          <span class="name">{{ item.id }}</span>
        </div>
        <div v-if="!unShowGroup" class="d-f">
          <span class="group" v-for="(group, iGroup) in item.actIdGroups" :key="iGroup">{{ group.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { avatarColor, avatarInitial } from '@/utils/avatar'

export default {
  data() {
    return {};
  },
  props: ['list', 'callback', 'unShowGroup'],
  methods: {
    // 无头像兜底：与 components/User.vue 同源（@/utils/avatar），保证同一个人全站同色
    avatarColor,
    avatarInitial,
    selectItem(item) {
      this.callback.call(this, item)
    },
  },
};
</script>
<style scoped>
.d-active {
  top: -25px;
}
</style>